/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 *
 * Jellyfin API
 *
 * This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at http://mozilla.org/MPL/2.0/.
 */
/**
 *
 * @export
 * @enum {string}
 */
const ProfileConditionValue = {
    AudioChannels: 'AudioChannels',
    AudioBitrate: 'AudioBitrate',
    AudioProfile: 'AudioProfile',
    Width: 'Width',
    Height: 'Height',
    Has64BitOffsets: 'Has64BitOffsets',
    PacketLength: 'PacketLength',
    VideoBitDepth: 'VideoBitDepth',
    VideoBitrate: 'VideoBitrate',
    VideoFramerate: 'VideoFramerate',
    VideoLevel: 'VideoLevel',
    VideoProfile: 'VideoProfile',
    VideoTimestamp: 'VideoTimestamp',
    IsAnamorphic: 'IsAnamorphic',
    RefFrames: 'RefFrames',
    NumAudioStreams: 'NumAudioStreams',
    NumVideoStreams: 'NumVideoStreams',
    IsSecondaryAudio: 'IsSecondaryAudio',
    VideoCodecTag: 'VideoCodecTag',
    IsAvc: 'IsAvc',
    IsInterlaced: 'IsInterlaced',
    AudioSampleRate: 'AudioSampleRate',
    AudioBitDepth: 'AudioBitDepth',
    VideoRangeType: 'VideoRangeType'
};

export { ProfileConditionValue };
